<template>
  <!-- A magnifier with a spark in place of its top-right arc: search, but the AI kind. Drawn here
       rather than pulled from an icon set -- no published set carries the combined glyph. Painted
       with the AI gradient, which an SVG can only take through a paint server. Callers size it.
       The spark overlaps the lens rather than sitting beside it -- its left point reaches inside
       the ring's radius -- which is why the arc is cut away across that stretch instead of just
       stopping short of it. -->
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <defs>
      <!-- userSpaceOnUse, not the default: an object bounding box would restart the gradient on
           each path and the spark would repeat the full sweep on its own.
           linear-gradient(150.4deg, ...) projected over the 24x24 box, running past the corners
           the way the CSS gradient line does. -->
      <linearGradient :id="gradientId" gradientUnits="userSpaceOnUse" x1="3.94" y1="-2.24" x2="20.06" y2="26.24">
        <stop offset="12.35%" stop-color="var(--color-ai-blue)" />
        <stop offset="96.71%" stop-color="var(--color-ai-magenta)" />
      </linearGradient>
    </defs>

    <!-- Ring, open across the upper right so the spark has room to sit against it. -->
    <path
      :stroke="`url(#${gradientId})`"
      stroke-width="2"
      stroke-linecap="round"
      d="M14.95 8.73A5.5 5.5 0 1 1 9.69 4" />

    <!-- Handle, leaving the ring on its lower-right diagonal. -->
    <path :stroke="`url(#${gradientId})`" stroke-width="2" stroke-linecap="round" d="M13.39 13.39 20.5 20.5" />

    <!-- Four-point spark, tucked into the opening. -->
    <path :fill="`url(#${gradientId})`" d="M16 0.4 14.5 4.4 10.5 5.9 14.5 7.4 16 11.4 17.5 7.4 21.5 5.9 17.5 4.4Z" />
  </svg>
</template>

<script lang="ts">
// A paint reference is document scoped, so instances sharing one id would all render from whichever
// defs mounted first -- and vanish when that one unmounts.
let instances = 0;
</script>

<script setup lang="ts">
instances += 1;
const gradientId = `ai-mode-gradient-${instances}`;
</script>
